import { useEffect, useCallback } from 'react';
import confetti from 'canvas-confetti';

interface ConfettiCelebrationProps {
  trigger: boolean;
  onComplete?: () => void;
  type?: 'badge' | 'milestone' | 'default';
}

export const ConfettiCelebration = ({ 
  trigger, 
  onComplete,
  type = 'default' 
}: ConfettiCelebrationProps) => {
  
  const fireConfetti = useCallback(() => {
    const defaults = {
      origin: { y: 0.7 },
      zIndex: 9999,
    };

    if (type === 'badge') {
      // Badge unlock - golden burst
      confetti({
        ...defaults,
        particleCount: 100,
        spread: 70,
        colors: ['#FFD700', '#FFA500', '#FF8C00', '#FFFFFF'],
        shapes: ['star', 'circle'],
      });
    } else if (type === 'milestone') {
      // Milestone - double burst
      const fire = (particleRatio: number, opts: confetti.Options) => {
        confetti({
          ...defaults,
          ...opts,
          particleCount: Math.floor(200 * particleRatio),
        });
      };

      fire(0.25, { spread: 26, startVelocity: 55 });
      fire(0.2, { spread: 60 });
      fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
      fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
      fire(0.1, { spread: 120, startVelocity: 45 });
    } else {
      // Default celebration
      confetti({
        ...defaults,
        particleCount: 50,
        spread: 60,
      });
    }

    onComplete?.();
  }, [type, onComplete]);

  useEffect(() => {
    if (trigger) {
      fireConfetti();
    }
  }, [trigger, fireConfetti]);

  return null;
};

// Utility function to trigger confetti imperatively
export const triggerConfetti = (type: 'badge' | 'milestone' | 'default' = 'default') => {
  const defaults = {
    origin: { y: 0.7 },
    zIndex: 9999,
  };

  if (type === 'badge') {
    confetti({
      ...defaults,
      particleCount: 100,
      spread: 70,
      colors: ['#FFD700', '#FFA500', '#FF8C00', '#FFFFFF'],
      shapes: ['star', 'circle'],
    });
  } else if (type === 'milestone') {
    const fire = (particleRatio: number, opts: confetti.Options) => {
      confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(200 * particleRatio),
      });
    };
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
  } else {
    confetti({
      ...defaults,
      particleCount: 50,
      spread: 60,
    });
  }
};
